import React from 'react';
import { connect } from 'react-redux';
import { lzCallApi } from '../../../../services/LzApiService';
import { lzShowSuccessMessage } from '../../../../services/LzUtils';
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import LzForm from '../../../commons/forms/form';
import LzFormFieldInput from '../../../commons/forms/fields/input';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import LzOptionModel from '../../../../models/option';
import DealerModel from '../../../../models/dealer';
import { lzDeepVarSet } from '../../../../services/LzType';

class UpdateRMAConfigsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            model: null,
            optionsHash: {},
        };
    }

    componentDidMount() {
        this.load();
    }

    getSelectOptions(key) {
        const { optionsHash } = this.state;

        if (optionsHash[key]) {
            return optionsHash[key];
        }

        setTimeout(() => this.loadSelectOptions(key), 200);
    }

    async loadSelectOptions(key) {
        const { optionsHash } = this.state;

        // If already loaded then skip
        if (optionsHash[key]) {
            return;
        }

        // Mark loading
        optionsHash[key] = 'loading';
        this.setState({
            optionsHash: optionsHash,
        });

        // Make the api call and get the data
        const data = await lzCallApi('options/' + key);

        // Load data if call was successful
        // console.log('CRUD OPTIONS DATA', key, data);
        optionsHash[key] = LzOptionModel.parseArray(data, 'id', 'name');
        this.setState({
            optionsHash: optionsHash,
        });
    }

    handleInputChange = (name, value) => {
        // console.log('SET', name, value);
        const data = Object.assign({}, this.state.model);
        lzDeepVarSet(data, name, value);
        this.setState({ model: data });
    };

    async load() {
        // Make the api call and get the data
        const data = await lzCallApi('rma-configs');

        // Load data if call was successful
        if (data) {
            this.setState({ model: data });
        }
    }

    async save() {
        const { model } = this.state;
        const { onUpdate } = this.props;

        // Make the api call and get processed data
        const data = await lzCallApi('rma-configs', new DealerModel(model), 'post');

        // Check if call was successful
        if (data) {
            lzShowSuccessMessage('Your configurations was successfully updated!');
            if (onUpdate) {
                onUpdate();
            }
        }
    }

    render() {
        const { model } = this.state;
        const { inlineWidget, allowSkip, onSkip, appConfig } = this.props;

        return (
            <React.Fragment>

                {model ?
                    <div className={inlineWidget ? 'lz-inline-widget' : ''}>

                        <LzForm
                            noCancel={!allowSkip} cancelLabel="Skip" onCancel={onSkip}
                            showReset resetLabel="Refresh" onReset={() => this.load()}
                            onSubmit={() => this.save()}
                        >
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <LzFormFieldInput fluid required label="TheGunDock API Connection Key" placeholder="please enter api connection key for TheGunDock API"
                                        name="tgd_api_connection_key" value={model?.tgd_api_connection_key || ''} onChange={this.handleInputChange} autoFocus />
                                </Grid>
                                <Grid item xs={12}>
                                    <LzFormFieldInput fluid label="EasyPost API Key" placeholder="please enter your api key for EasyPost API"
                                        name="easypost_api_key" value={model?.easypost_api_key || ''} onChange={this.handleInputChange} />
                                </Grid>
                                <Grid item xs={12}>
                                    <LzFormFieldInput fluid label="Label Notifications Email" placeholder="please enter the default email address to receive a copy of labels"
                                        name="rma_label_notif_email" value={model?.rma_label_notif_email || ''} onChange={this.handleInputChange} />
                                </Grid>
                            </Grid>

                        </LzForm>
                    </div>
                    :
                    <CircularProgress color="inherit" />
                }

            </React.Fragment>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        appConfig: state.commons.appConfig,
    }
};

export default connect(
    mapStateToProps
)(UpdateRMAConfigsComponent);
